import { ButtonProps, ListItemText, ListItemTextProps, css, styled } from '@mui/material'

export interface MenuItemTextProps extends ListItemTextProps {
  color?: ButtonProps['color']
}

const MenuItemText = styled((props: MenuItemTextProps) => <ListItemText {...props} />, {
  shouldForwardProp: (prop) => prop !== 'color',
})`
  overflow-wrap: break-word;
  white-space: break-spaces;

  & .MuiListItemText-secondary {
    ${({ theme }) => theme.typography.caption};
    line-height: 1.3;
    margin-top: 2px;
    ${({ color, theme }) =>
      !color &&
      css`
        color: ${theme.palette.grey[600]};
      `};
  }

  ${({ color, theme }) =>
    color &&
    css`
      & .MuiTypography-root {
        color: ${theme.palette[color].main};
      }
    `}
`

export default MenuItemText
